export default {
  colors: {
    brownishGrey: '#efe7d1',
    darkTurquoise: '#8ac2e5',
    darkBrown: '#483e3e',
    faintLimeGreen: '#0ddb588c',
    grey: '#4b6b7e',
    lightBlack: '#323232',
    lightBlue: '#dcffffde',
    lightTurquoise: '#8dd0e5',
    lilac: '#9a8ae5',
    limeGreen: '#37d486',
    midBlue: '#3789d4',
    pastelBlue: '#6785e1',
    pink: '#ffa5ac',
    transparent: 'rgba(0, 0, 0, 0)',
    white: '#ffffff'
  }
};
